import { InputBatchSelection } from './input-batch-selection';

export class EmptyInputBatchSelection extends InputBatchSelection {
	public constructor() {
		super(undefined);
	}
}
